import { AppImages } from '@/app'
import { Animations, AnimationsProps } from './Animations'

const animation = AppImages.loadingAnimation

export const ActivityIndicatorCP = (props: Partial<AnimationsProps> = {}) => {
  return <Animations animation={animation} autoplay loop {...props} />
}
